import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { forwardRef, memo } from "react";
import useToggle from "../../hooks/useToggle";

const Input = forwardRef((props, ref) => {
  const {
    placeholder = "Type ...",
    type = "text",
    value,
    onChange,
    label,
    helpertext,
    className = "",
    wrapperClassName = "",
    error,
    required,
    options = [],
    disabled = false,
    max,
    name,
    ...rest
  } = props;

  const [show, _, toggle] = useToggle();

  let class_name = "site-input border-input ";
  let wrapper_class_name = "position-relative";

  if (type == "password") {
    class_name = class_name + "enter-input";
    rest.autoComplete = "new-password";
    rest.autoCorrect = "off";
    rest.spellCheck = false;
  } else if (type === "radio") {
    class_name = "";
  } else {
    class_name = class_name + " mt-2";
  }

  class_name = class_name + " " + className;
  wrapper_class_name = wrapper_class_name + " " + (wrapperClassName || "mt-3");

  const renderInput = (props) => {
    if (type === "textarea") {
      return <textarea {...props} ref={ref} />;
    }
    return <input {...props} ref={ref} max={max} />;
  };

  if (type === "radio" && options?.length > 0) {
    return (
      <div>
        {label && (
          <label>
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}
        <div className={`${class_name}`}>
          {options.map((option, index) => (
            <label
              key={index}
              className="radio-label d-flex gap-2"
              style={{
                cursor: disabled ? "not-allowed" : "pointer",
                opacity: disabled ? 0.6 : 1,
                pointerEvents: disabled ? "none" : "auto",
              }}
            >
              <input
                type="radio"
                name={name}
                value={option.value}
                checked={value === option.value}
                onChange={onChange}
                disabled={disabled}
                {...rest}
              />
              <span className="custom-radio" />
              {option.label}
            </label>
          ))}
        </div>
        {helpertext && (
          <p className="m-0 p-xs light">
            <em>{helpertext}</em>
          </p>
        )}
        {error && <p className="m-0 mt-1 p-sm text-danger ms-3">{error}</p>}
      </div>
    );
  }

  return (
    <>
      <div className={wrapper_class_name}>
        {label && (
          <label>
            {label} {required && <span className="text-danger">*</span>}
          </label>
        )}

        {type === "select" ? (
          <select
            className={class_name}
            onChange={onChange}
            value={value}
            ref={ref}
            {...rest}
          >
            <option value="" disabled>
              {props?.placeholder || "Select"}
            </option>
            {options.map((item, index) => (
              <option key={index} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
        ) : (
          <div>
            {renderInput({
              type: type === "password" && show ? "text" : type,
              placeholder,
              className: class_name,
              value,
              onChange,
              style: error ? { border: "1px solid red" } : {},
              disabled,
              ...rest,
            })}
            {type === "password" && (
              <button
                className="transparent-btn right-icon enter-icon grey-text"
                type="button"
                onClick={toggle}
              >
                <FontAwesomeIcon icon={show ? "eye" : "eye-slash"} />
              </button>
            )}
          </div>
        )}

        {helpertext && (
          <p className="m-0 p-xs light">
            <em>{helpertext}</em>
          </p>
        )}
      </div>
      {error && <p className="m-0 mt-1 p-sm text-danger ms-3">{error}</p>}
    </>
  );
});

Input.displayName = "Input";

export default memo(Input);
